import React from "react";

interface ErrorProp {
  classStyle?: string;
  message: string | any;
}
const ErrorMessage = ({ classStyle, message = "" }: ErrorProp) => {
  if (!message?.length) return <></>;
  return (
    <>
      <p
        className={`${classStyle} text-danger p-0 m-0 ps-1`}
        style={{ fontSize: "12px" }}
      >
        {message}
        {/* This field is required! */}
      </p>
    </>
  );
};

export default ErrorMessage;
